
// Action: file_editor create /app/frontend/src/components/WhatsAppButton.js --file-text 
import React from 'react';
import { MessageCircle } from 'lucide-react';

const WhatsAppButton = () => {
  const phoneNumber = '919599173367'; // Replace with actual WhatsApp number
  const message = 'Hello! I would like to inquire about your interior design services.';
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      
      rel="noopener noreferrer"
      data-testid="whatsapp-float-button"
      className="fixed bottom-8 right-8 z-50 bg-[#25D366] text-white p-4 rounded-full shadow-2xl hover:scale-110 transition-transform duration-300 group"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle size={28} className="group-hover:animate-pulse" />
      <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-[#1A1A1A] text-white px-4 py-2 rounded-lg text-sm font-manrope whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300">
        Chat with us!
      </span>
    </a>
  );
};

export default WhatsAppButton;
// Observation: Create successful: /app/frontend/src/components/WhatsAppButton.js